












import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import Container from '@/components/layout/Container.vue';
import TeaserVideo from '@/components/landing/TeaserVideo.vue';

import LocaleMixin from '@/mixins/locale';

import { COVER, TRAILERS } from '@/config/teaser';

@Component({
  components: { Container, TeaserVideo },
})
export default class TeaserSection extends mixins(LocaleMixin) {
  paused = true;

  get cover() {
    if (this.$appName === undefined) {
      return {};
    }
    return COVER[this.$appName];
  }

  get source() {
    if (this.$appName === undefined) {
      return {};
    }
    return TRAILERS[this.$appName][this.locale] || TRAILERS[this.$appName].en;
  }

  handlePaused(paused: boolean) {
    this.paused = paused;
  }
}
